// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import * as React from "react";
import { useEffect, useState } from "react";

interface ProductOptionContextProps {
    product: ProductModel;
    productInfo: ProductInfo;
}

const ProductOptionContext: React.FC<ProductOptionContextProps> = ({ product, productInfo, children }) => {
    const [productInfoState, setProductInfoState] = useState(productInfo);

    useEffect(() => {
        setProductInfoState(productInfo);
    }, [productInfo]);

    const onQtyChange = (qty: number) => {
        setProductInfoState({
            ...productInfoState,
            qtyOrdered: qty,
        });
    };

    const productContext: ProductContextModel = {
        product,
        productInfo: productInfoState,
        onQtyOrderedChanged: onQtyChange,
    };

    return <ProductContext.Provider value={productContext}>{children}</ProductContext.Provider>;
};

export default ProductOptionContext;
